module.exports = __webpack_public_path__ + "media/images/stripe/blue-on-dark@3x-804e2f1328073d6c1c80ae6108b58482.png";